<template>
  <PlaceholderPantalla
    titulo="Ajustes de Inventario"
    subtitulo="Correcciones y conteos físicos de inventario"
    descripcion="Realiza ajustes de inventario cuando hay diferencias entre el stock físico y el sistema. Registra conteos cíclicos, inventarios físicos completos, y ajusta cantidades por correcciones, roturas, o discrepancias encontradas durante auditorías."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Crear conteos físicos de inventario programados',
  'Registrar ajustes por diferencias entre físico y sistema',
  'Ajustes masivos por producto o por almacén',
  'Calcular diferencias (sobrantes o faltantes)',
  'Análisis de causas de las diferencias',
  'Autorización de ajustes por supervisor',
  'Actualización automática de stocks',
  'Afectación al costo de ventas según el ajuste',
  'Historial completo de ajustes',
  'Reportes de exactitud de inventario (%)',
  'Conteos cíclicos por categoría o zona',
  'Importar conteos desde Excel',
  'Comparación antes/después del ajuste',
  'Alertas de diferencias significativas',
  'Auditoría de ajustes por usuario'
]

const datosManejados = [
  'Fecha del conteo/ajuste',
  'Tipo de ajuste (Conteo físico, Corrección, Merma encontrada)',
  'Producto o materia prima',
  'Stock en sistema (antes)',
  'Stock físico contado',
  'Diferencia (+ o -)',
  'Costo del ajuste',
  'Motivo del ajuste',
  'Causas identificadas',
  'Responsable del conteo',
  'Supervisor que autoriza',
  'Estado de autorización',
  'Ubicación en almacén',
  'Lote afectado',
  'Notas y observaciones',
  'Evidencias fotográficas',
  'Usuario que registró'
]
</script>
